import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DatasetLinkedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dataset_linked"}/>
}
